export default class Point {
  public x = 0;
  public y = 0;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  scale(factor: number): Point {
    return new Point(this.x * factor, this.y * factor);
  }

  clone(): Point {
    return new Point(this.x, this.y);
  }


  fromJSON(data: any) {
    this.x = data.x;
    this.y = data.y;
  }
}
